var exports = {
  "k": "x4c3adb35--547df4--container",
  "Q": "x4c3adb35--547df4--text",
};

module.exports = exports;
